import React from 'react';
import { NFTData } from '../types';

interface NFTCardProps {
  nft: NFTData;
  onClick: () => void;
}

const NFTCard: React.FC<NFTCardProps> = ({ nft, onClick }) => {
  const getImageSrc = () => {
    if (nft.metadata.svg) {
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(nft.metadata.svg)}`;
    }
    if (nft.metadata.image) {
      const img = nft.metadata.image;
      return img.startsWith('ipfs://') 
        ? img.replace('ipfs://', 'https://gateway.pinata.cloud/ipfs/')
        : img;
    }
    return null;
  };

  const imageSrc = getImageSrc();

  return (
    <div
      className="card"
      onClick={onClick}
    >
      <div className="card-media">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={nft.metadata.name}
            className="card-img"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const fallback = target.nextElementSibling as HTMLElement;
              if (fallback) fallback.style.display = 'flex';
            }}
          />
        ) : null}
        <div 
          className="card-fallback"
          style={{ display: imageSrc ? 'none' : 'flex' }}
        >
          No Image
        </div>
      </div>
      <div className="card-body">
        <h3 className="card-title">
          {nft.metadata.name}
        </h3>
        
        {nft.siteName && (
          <div className="card-site">
            📄 {nft.siteName}
          </div>
        )}
        
        <div className="card-meta">Token #{nft.tokenId}</div>
      </div>
    </div>
  );
};

export default NFTCard;
